import classes from "./Profile.module.css"
import { useTranslation } from "react-i18next"
import { get_catalogue, getElemFromProp, gearImage, emoteImage, lockerImage } from "../../Utils"
import { useState } from "react"
import Input from "../../components/UI/Input/Input"
import { BynameAdjectiveString, BynameSubjectString, BynameAdjectiveList, BynameSubjectList } from "../Byname/Byname"
import { NamePlateBG, NamePlateBGList } from "../NamePlateBg/NamePlateBg"
import { useLocalStorage, CURRENT_SEASON, getSkillId } from "../../Utils"
import { defaultGearList, defaultProfile } from "../../DefaultEntries"
import {
    toggle_byname_adjective,
    toggle_byname_subject,
    toggle_emote,
    toggle_nameplate,
} from "../SeedLister/Util/ProfileHandler"

const SettingsPage = props => {
    const { t } = useTranslation()

    const [profile, setProfile] = useLocalStorage("profile", defaultProfile)
    const [gearDB, addGearToDB] = useLocalStorage("gearList", defaultGearList)

    const [open, setOpen] = useState(false)
    const [open2, setOpen2] = useState(false)
    const [open3, setOpen3] = useState(false)
    const [onlyOwned, setOnlyOwned] = useState(false)
    const [onlyOwned2, setOnlyOwned2] = useState(false)
    const [onlyOwned3, setOnlyOwned3] = useState(false)

    const setLevel = val => {
        const original_profile = {
            ...profile,
            Level: val,
        }
        setProfile(original_profile)
    }

    const changeLevel = lvl => {
        const level = lvl.target.value
        if (level < 1) {
            setLevel(1)
        } else if (level > 999) {
            setLevel(999)
        } else {
            setLevel(level)
        }
    }

    const setBynameAdjective = key => {
        toggle_byname_adjective(key, profile, setProfile)
    }

    const setBynameSubject = key => {
        toggle_byname_subject(key, profile, setProfile)
    }

    const setNamePlateBG = key => {
        toggle_nameplate(key, profile, setProfile)
    }

    const setEmote = key => {
        toggle_emote(key, profile, setProfile)
    }

    const setGoods = key => {
        const original = { ...profile.GoodsMap }
        if (parseInt(key) in original) {
            delete original[parseInt(key)]
        } else {
            original[parseInt(key)] = 1
        }
        const original_profile = {
            ...profile,
            GoodsMap: original,
        }
        setProfile(original_profile)
    }

    const get_catalogues = key => {
        const c = []
        for (let i = 0; i < CURRENT_SEASON; i++) {
            c.push(i)
        }
        return c
    }

    const add_gear = (type, key) => {
        const original = { ...gearDB[type] }
        const original_all = { ...gearDB }
        original[key.Id] = {
            ExSkillArray: [],
            ExDrinksArray: [],
            MainSkill: getSkillId(key.Skill),
            RandomContext: 0,
        }
        original_all[type] = original
        addGearToDB(original_all)
    }

    const catalogue = get_catalogues()

    return (
        <div>
            <h2>{t("misc:Profile.General")}</h2>
            <Input
                type="number"
                title={t("translation:LayoutMsg.Cmn_Menu_00.L_Rank_00-T_RankHeader_00")}
                val={profile.Level}
                changed={changeLevel}
                min={1}
                max={999}
            />
            {catalogue.map(idx => (
                <Catalogue
                    num={idx + 1}
                    key={idx + 1}
                    setBynameAdjective={setBynameAdjective}
                    BynameAdjectiveMap={profile.BynameAdjectiveMap}
                    setBynameSubject={setBynameSubject}
                    BynameSubjectMap={profile.BynameSubjectMap}
                    setNamePlateBG={setNamePlateBG}
                    NamePlateBgMap={profile.NamePlateBgMap}
                    gearDB={gearDB}
                    EmoteMap={profile.EmoteMap}
                    GoodsMap={profile.GoodsMap}
                    setEmote={setEmote}
                    setGoods={setGoods}
                    add_gear={add_gear}
                />
            ))}
            <h2>{t("translation:CommonMsg.Glossary.Byname")}</h2>
            <h3>
                1{" "}
                <span className={classes.arrow} onClick={() => setOpen(!open)}>
                    {!open ? "▶" : "▼"}
                </span>
            </h3>
            <div style={{ fontSize: "large" }}>
                {t("translation:LayoutMsg.Cmn_CstBase_00.L_BtnList_08-T_SoldOut_00")}:{" "}
                {Object.values(profile.BynameAdjectiveMap).filter(v => v).length}
            </div>
            <Input
                type="checkbox"
                title={t("misc:Profile.ShowOnlyOwned")}
                val={onlyOwned}
                labelClick={true}
                changed={() => setOnlyOwned(e => !e)}
            />
            <div className={classes.BynameList}>
                {open ? (
                    <BynameAdjectiveList
                        owned={profile.BynameAdjectiveMap}
                        store={setBynameAdjective}
                        showOnlyOwned={onlyOwned}
                    />
                ) : null}
            </div>

            <h3>
                2{" "}
                <span className={classes.arrow} onClick={() => setOpen2(!open2)}>
                    {!open2 ? "▶" : "▼"}
                </span>
            </h3>
            <div style={{ fontSize: "large" }}>
                {t("translation:LayoutMsg.Cmn_CstBase_00.L_BtnList_08-T_SoldOut_00")}:{" "}
                {Object.values(profile.BynameSubjectMap).filter(v => v).length}
            </div>
            <div>
                <Input
                    type="checkbox"
                    title={t("misc:Profile.ShowOnlyOwned")}
                    val={onlyOwned2}
                    labelClick={true}
                    changed={() => setOnlyOwned2(e => !e)}
                />
            </div>
            <div className={classes.BynameList}>
                {open2 ? (
                    <BynameSubjectList
                        owned={profile.BynameSubjectMap}
                        store={setBynameSubject}
                        showOnlyOwned={onlyOwned2}
                    />
                ) : null}
            </div>
            <h2>
                {t("translation:CommonMsg.Glossary.NamePlateBg")}{" "}
                <span className={classes.arrow} onClick={() => setOpen3(!open3)}>
                    {!open3 ? "▶" : "▼"}
                </span>
            </h2>
            <div style={{ fontSize: "large" }}>
                {t("translation:LayoutMsg.Cmn_CstBase_00.L_BtnList_08-T_SoldOut_00")}:{" "}
                {Object.values(profile.NamePlateBgMap).filter(v => v).length}
            </div>
            <Input
                type="checkbox"
                title={t("misc:Profile.ShowOnlyOwned")}
                val={onlyOwned3}
                labelClick={true}
                changed={() => setOnlyOwned3(e => !e)}
            />
            <div className={classes.BynameList}>
                {open3 ? (
                    <NamePlateBGList
                        owned={profile.NamePlateBgMap}
                        store={setNamePlateBG}
                        reverse={true}
                        showOnlyOwned={onlyOwned3}
                    />
                ) : null}
            </div>
        </div>
    )
}

const Catalogue = props => {
    const [open, setOpen] = useState(false)
    const this_catalogue = get_catalogue(props.num).ItemArray
    const { t } = useTranslation()

    return (
        <>
            <h2>
                {t("translation:LayoutMsg.Cmn_Menu_00.L_Player_01-T_BlackText_00")} {props.num}{" "}
                <span className={classes.arrow} onClick={() => setOpen(!open)}>
                    {!open ? "▶" : "▼"}
                </span>
            </h2>
            {open ? (
                <div className={classes.ProfileFlex}>
                    {this_catalogue.map((e, i) => (
                        <ElemParser Item={e} Level={i + 1} key={i} {...props} />
                    ))}
                </div>
            ) : null}
        </>
    )
}

const ElemParser = props => {
    const [t] = useTranslation()

    const parse = () => {
        switch (props.Item.Type) {
            case "NamePlateBg":
                const np = getElemFromProp(props.Item)
                return (
                    <div className={classes.CatalogueElem}>
                        <div className={classes.ProfileLevel}>
                            {t("translation:LayoutMsg.Cmn_Menu_00.L_Rank_00-T_RankHeader_00")} {props.Level}
                        </div>
                        <center>
                            <NamePlateBG
                                elem={np}
                                store={props.setNamePlateBG}
                                owned={props.NamePlateBgMap[np.Id] ?? false}
                            />
                        </center>
                    </div>
                )
            case "Byname":
                const [a, s] = getElemFromProp(props.Item)
                return (
                    <div className={classes.CatalogueElem}>
                        <div className={classes.ProfileLevel}>
                            {t("translation:LayoutMsg.Cmn_Menu_00.L_Rank_00-T_RankHeader_00")} {props.Level}
                        </div>
                        <center>
                            <BynameAdjectiveString
                                num={a}
                                store={props.setBynameAdjective}
                                owned={props.BynameAdjectiveMap[parseInt(a)] ?? false}
                            />
                        </center>
                        <center>
                            <BynameSubjectString
                                num={s}
                                store={props.setBynameSubject}
                                owned={props.BynameSubjectMap[parseInt(s)] ?? false}
                            />
                        </center>
                    </div>
                )
            case "Gear_Head":
                return (
                    <GearPiece
                        elem={getElemFromProp(props.Item)}
                        Level={props.Level}
                        gearDB={props.gearDB.HaveGearHeadMap}
                        add_gear={props.add_gear}
                        type={"HaveGearHeadMap"}
                    />
                )
            case "Gear_Clothes":
                return (
                    <GearPiece
                        elem={getElemFromProp(props.Item)}
                        Level={props.Level}
                        gearDB={props.gearDB.HaveGearClothesMap}
                        add_gear={props.add_gear}
                        type={"HaveGearClothesMap"}
                    />
                )
            case "Gear_Shoes":
                return (
                    <GearPiece
                        elem={getElemFromProp(props.Item)}
                        Level={props.Level}
                        gearDB={props.gearDB.HaveGearShoesMap}
                        add_gear={props.add_gear}
                        type={"HaveGearShoesMap"}
                    />
                )
            case "Emote":
                const e = getElemFromProp(props.Item)
                return (
                    <EmotePiece
                        elem={e}
                        Level={props.Level}
                        store={() => props.setEmote(e.Id)}
                        owned={props.EmoteMap[parseInt(e.Id)] ?? false}
                    />
                )
            case "LockerSticker":
                const ls = getElemFromProp(props.Item)
                return (
                    <LockerPiece
                        elem={ls}
                        Level={props.Level}
                        store={() => props.setGoods(ls.Id)}
                        owned={props.GoodsMap[parseInt(ls.Id)] > 0 ?? false}
                    />
                )
            case "LockerFigure":
                const lf = getElemFromProp(props.Item)
                return (
                    <LockerPiece
                        elem={lf}
                        Level={props.Level}
                        store={() => props.setGoods(lf.Id)}
                        owned={props.GoodsMap[parseInt(lf.Id)] > 0 ?? false}
                    />
                )
            case "GearPack":
                const gp = getElemFromProp(props.Item)
                return (
                    <div>
                        <GearPiece
                            elem={gp[0]}
                            Level={props.Level}
                            gearDB={props.gearDB.HaveGearHeadMap}
                            add_gear={props.add_gear}
                            type={"HaveGearHeadMap"}
                        />
                        <GearPiece
                            elem={gp[1]}
                            Level={props.Level}
                            gearDB={props.gearDB.HaveGearClothesMap}
                            add_gear={props.add_gear}
                            type={"HaveGearClothesMap"}
                        />
                        <GearPiece
                            elem={gp[2]}
                            Level={props.Level}
                            gearDB={props.gearDB.HaveGearShoesMap}
                            add_gear={props.add_gear}
                            type={"HaveGearShoesMap"}
                        />
                    </div>
                )
            default:
                return null
        }
    }

    return parse()
}

const GearPiece = props => {
    const [t] = useTranslation()

    if (props.elem.HowToGet !== "Catalog") {
        return null
    }
    return (
        <div className={classes.CatalogueElem}>
            <div className={classes.ProfileLevel}>
                {t("translation:LayoutMsg.Cmn_Menu_00.L_Rank_00-T_RankHeader_00")} {props.Level}
            </div>
            <center>
                <Input
                    type="checkbox"
                    title={t("translation:LayoutMsg.Cmn_CstBase_00.L_BtnList_08-T_SoldOut_00")}
                    val={props.elem.Id in props.gearDB}
                    labelClick={true}
                    disabled={props.elem.Id in props.gearDB}
                    changed={() => props.add_gear(props.type, props.elem)}
                />

                <img src={gearImage(props.elem.__RowId)} alt={props.elem.__RowId} width={128} />
            </center>
        </div>
    )
}

const EmotePiece = props => {
    const [t] = useTranslation()

    return (
        <div className={classes.CatalogueElem}>
            <div className={classes.ProfileLevel}>
                {t("translation:LayoutMsg.Cmn_Menu_00.L_Rank_00-T_RankHeader_00")} {props.Level}
            </div>
            <center>
                <Input
                    type="checkbox"
                    title={t("translation:LayoutMsg.Cmn_CstBase_00.L_BtnList_08-T_SoldOut_00")}
                    val={props.owned}
                    labelClick={true}
                    changed={() => props.store(props.num)}
                />
                <img src={emoteImage(props.elem.__RowId)} alt={props.elem.__RowId} width={128} />
            </center>
        </div>
    )
}

const LockerPiece = props => {
    const [t] = useTranslation()

    return (
        <div className={classes.CatalogueElem}>
            <div className={classes.ProfileLevel}>
                {t("translation:LayoutMsg.Cmn_Menu_00.L_Rank_00-T_RankHeader_00")} {props.Level}
            </div>
            <center>
                <Input
                    type="checkbox"
                    title={t("translation:LayoutMsg.Cmn_CstBase_00.L_BtnList_08-T_SoldOut_00")}
                    val={props.owned}
                    labelClick={true}
                    changed={() => props.store(props.num)}
                />
                <img src={lockerImage(props.elem.__RowId)} alt={props.elem.__RowId} width={128} />
            </center>
        </div>
    )
}

export default SettingsPage
